/** Host Ivon-E (branche main) → logo Odytics au lieu de SITES. */
export function isIvonEHost() {
  return window.location.hostname === 'inspection.ivon-e.ch';
}

export function getBrandAlt() {
  return isIvonEHost() ? 'Odytics' : 'SITES';
}

export function getLoginLogoSrc() {
  return isIvonEHost() ? '/logo-odytics.png' : '/logo-sites.png';
}

export function getHeaderLogoSrc() {
  return isIvonEHost() ? '/logo-odytics.png' : '/small-logo-sites.jpg';
}

/** Titre onglet navigateur hors inspection. */
export function getDefaultDocumentTitle() {
  return isIvonEHost() ? 'Ivon-e' : 'Sites Orthophoto viewer';
}
